import { GET_LAST_LOG, GET_LIST_PRESENSI } from "shared/constants/ActionTypes";

const initialState = {
    list: null,
    lastLog: null
}

const presensiReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LIST_PRESENSI:
            return {
                ...state,
                list: action.payload
            }
        case GET_LAST_LOG:
            return {
                ...state,
                lastLog: action.payload
            }
        default:
            return state
    }
}

export default presensiReducer